<script lang="ts">
  import ThumbDownOutline from "$assets/icons/thumb-down-outline.svelte";
  import ThumbDown from "$assets/icons/thumb-down.svelte";
  import ThumbUpOutline from "$assets/icons/thumb-up-outline.svelte";
  import ThumbUp from "$assets/icons/thumb-up.svelte";
  import { Form } from "$ui/form";
  import Textarea from "$lib/ui/textarea/textarea.svelte";
  import * as yup from "yup";
  import { makeApiRequest } from "$lib/utils/api";
  import { selectedOrgStore } from "$lib/stores/orgs";
  import { toaster } from "$lib/utils/toaster";
  import SubmitButton from "$lib/ui/submit-button/submit-button.svelte";
  import type { SecurityFinding } from "$lib/stores/orgSecurityFindings";

  let {
    finding,
  }: {
    finding: SecurityFinding;
  } = $props();

  const org = $selectedOrgStore;

  type Expression = "like" | "dislike";
  interface Feedback {
    expression?: Expression;
    comment?: string;
  }
  let initialValues: Feedback = {
    expression: undefined,
    comment: undefined,
  };
  const validationSchema = yup.object().shape({
    expression: yup.string().required("Expression cannot be empty"),
    comment: yup.string().required("Comment cannot be empty"),
  });

  let form = $state();
  let validateField: (field?: any) => any;
  let isSubmitting = $state();
  let touched = $state();
  let errors = $state();

  const onSubmit = async (feedback: Feedback) => {
    try {
      await makeApiRequest(`${org?.resourcePrefix}/findings/${finding.id}/feedback`, feedback, "POST");
      $form.expression = initialValues.expression;
      $form.comment = initialValues.comment;
    } catch (err) {
      toaster.error("Oops", "Something went wrong, please try again.");
      throw err;
    }
  };
  const onSuccess = () => {
    toaster.success("Feedback is submitted", "Thank you for providing use feedback!");
  };
</script>

<div class="p-2 bg-purple-100 rounded-md">
  <div class="flex gap-4">
    <p class="flex-1 font-bold text-md">Provide your feedback on this Issue</p>
    <button
      class="w-5 h-5"
      onclick={() => {
        if ($form) {
          $form.expression = $form.expression !== "like" ? "like" : undefined;
        }
      }}
    >
      {#if $form?.expression !== "like"}
        <ThumbUpOutline />
      {/if}
      {#if $form?.expression === "like"}
        <ThumbUp />
      {/if}
    </button>
    <button
      class="w-5 h-5"
      onclick={() => {
        if ($form) {
          $form.expression = $form.expression !== "dislike" ? "dislike" : undefined;
        }
      }}
    >
      {#if $form?.expression !== "dislike"}
        <ThumbDownOutline />
      {/if}
      {#if $form?.expression === "dislike"}
        <ThumbDown />
      {/if}
    </button>
  </div>
  <Form
    {initialValues}
    {validationSchema}
    {onSubmit}
    {onSuccess}
    standaloneForm={false}
    bind:form
    bind:errors
    bind:validateField
    bind:isSubmitting
    bind:touched
  >
    {#if $form}
      <input name="expression" type="hidden" bind:value={$form.expression} />
      {#if $form.expression}
        <div class="py-2">
          <Textarea
            name="comment"
            placeholder="Add your feedback here... (e.g. Any concerns about the result?)"
            bind:value={$form.comment}
            error={$errors?.comment}
            oninput={() => {
              validateField && validateField("comment");
            }}
          />
        </div>
        <div class="flex-1 flex items-end">
          <SubmitButton {isSubmitting} {errors} {touched}>
            {#if $isSubmitting}
              Sending
            {:else}
              Send
            {/if}
          </SubmitButton>
        </div>
      {/if}
    {/if}
  </Form>
</div>
